import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import {
    Accordion,
    AccordionItem,
    AccordionItemPanel,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemState,
} from "react-accessible-accordion";
const produccion = require("assets/img/icons/produccion.png");
const produccion_activo = require("assets/img/icons/produccion_activo.png");

export const ProduccionV2Item = ({
    permisos,
    proveedor,
    proveedor_admin,
    location,
    moduloId,
    isItemSelected,
}) => {
    if (!permisos) return null;
    if (
        !permisos.creacion_ordenes_produccion &&
        !permisos.turnos_produccion &&
        !permisos.produccion_reportes &&
        !permisos.produccion_cierres_mensuales
    )
        return null;
    if (proveedor === true || proveedor_admin === true) return null;

    return (
        <div className="nav-item">
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton>
                        <AccordionItemState>
                            {({ expanded }) => {
                                const isSelected = isItemSelected(
                                    moduloId,
                                    location.hash,
                                    expanded,
                                );

                                return (
                                    <div
                                        className={`nav-link ${isSelected ? "active" : ""}`}
                                    >
                                        <img
                                            src={
                                                isSelected
                                                    ? produccion_activo
                                                    : produccion
                                            }
                                            className="icon-menu"
                                            alt=""
                                        />
                                        PRODUCCIÓN
                                    </div>
                                );
                            }}
                        </AccordionItemState>
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemState>
                    {({ expanded }) => {
                        const isSelected = isItemSelected(
                            moduloId,
                            location.hash,
                            expanded,
                        );

                        return (
                            isSelected && (
                                <AccordionItemPanel
                                    className={
                                        isSelected ? "acordion-expanded" : ""
                                    }
                                >
                                    <div className="pb-2">
                                        {permisos.creacion_ordenes_produccion &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-v2/producciones"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-v2/producciones",
                                                            )
                                                        }
                                                    >
                                                        PRODUCCIONES
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.turnos_produccion &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-v2/turnos-produccion"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-v2/turnos-produccion",
                                                            )
                                                        }
                                                    >
                                                        TURNOS
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.produccion_cierres_mensuales &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-v2/cierres-mensuales"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-v2/cierres-mensuales",
                                                            )
                                                        }
                                                    >
                                                        CIERRES MENSUALES
                                                    </NavLink>
                                                </div>
                                            )}
                                        {permisos.produccion_reportes &&
                                            proveedor === false &&
                                            proveedor_admin === false && (
                                                <div className="sub-nav-item">
                                                    <NavLink
                                                        to="/produccion-v2/reportes"
                                                        exact
                                                        className="nav-link "
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        isActive={(
                                                            match,
                                                            location,
                                                        ) =>
                                                            location.pathname.includes(
                                                                "/produccion-v2/reportes",
                                                            )
                                                        }
                                                    >
                                                        REPORTES
                                                    </NavLink>
                                                </div>
                                            )}
                                    </div>
                                </AccordionItemPanel>
                            )
                        );
                    }}
                </AccordionItemState>
            </AccordionItem>
        </div>
    );
};
